import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetPassword, getUser } from "../api";
import ClientHeader from "./ClientHeader";

const ResetPassword = ({ user, onLogout }) => {
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const [showNewPassword, setShowNewPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const currentUser = user || getUser();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        setSuccess("");

        if (newPassword !== confirmPassword) {
            setError("Passwords do not match");
            return;
        }

        if (newPassword.length < 8) {
            setError("Password must be at least 8 characters long");
            return;
        }

        setLoading(true);
        try {
            await resetPassword(currentUser.email, newPassword);
            setSuccess("Password reset successfully! Redirecting...");
            setTimeout(() => {
                navigate("/sessions");
            }, 2000);
        } catch (err) {
            setError(err.message || "Failed to reset password");
        } finally {
            setLoading(false);
        }
    };

    const EyeIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
            <circle cx="12" cy="12" r="3"></circle>
        </svg>
    );

    const EyeOffIcon = () => (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M17.94 17.94A10.07 10.07 0 0 1 12 20c-7 0-11-8-11-8a18.45 18.45 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19m-6.72-1.07a3 3 0 1 1-4.24-4.24"></path>
            <line x1="1" y1="1" x2="23" y2="23"></line>
        </svg>
    );

    return (
        <div className="sessions-page-container">
            <ClientHeader user={currentUser} onLogout={onLogout} />
            <main className="cr-page">
                <div className="cr-login-wrapper" style={{ minHeight: 'calc(100vh - 200px)' }}>
                    <div className="cr-login-card">
                        <h2 className="cr-login-title">Reset Password</h2>
                        <p className="cr-login-subtitle">Enter your new password below</p>

                        <form onSubmit={handleSubmit}>
                            <div className="cr-form-group" style={{ textAlign: 'left' }}>
                                <label className="cr-form-label">New Password</label>
                                <div className="cr-password-input-wrapper">
                                    <input
                                        type={showNewPassword ? "text" : "password"}
                                        className="cr-form-input"
                                        style={{ paddingRight: '40px' }}
                                        value={newPassword}
                                        onChange={(e) => setNewPassword(e.target.value)}
                                        placeholder="Enter new password"
                                        required
                                    />
                                    <button 
                                        type="button" 
                                        className="cr-password-toggle-btn"
                                        onClick={() => setShowNewPassword(!showNewPassword)}
                                    >
                                        {showNewPassword ? <EyeOffIcon /> : <EyeIcon />}
                                    </button>
                                </div>
                            </div>

                            <div className="cr-form-group" style={{ textAlign: 'left' }}>
                                <label className="cr-form-label">Confirm Password</label>
                                <div className="cr-password-input-wrapper">
                                    <input
                                        type={showConfirmPassword ? "text" : "password"}
                                        className="cr-form-input"
                                        style={{ paddingRight: '40px' }}
                                        value={confirmPassword}
                                        onChange={(e) => setConfirmPassword(e.target.value)}
                                        placeholder="Confirm new password"
                                        required
                                    />
                                    <button 
                                        type="button" 
                                        className="cr-password-toggle-btn"
                                        onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    >
                                        {showConfirmPassword ? <EyeOffIcon /> : <EyeIcon />}
                                    </button>
                                </div>
                            </div>

                            {error && <div className="cr-alert cr-alert-error">{error}</div>}
                            {success && <div className="cr-alert cr-alert-success">{success}</div>}

                            <button
                                type="submit"
                                className="cr-load-more-btn"
                                style={{ width: '100%', marginTop: '10px' }}
                                disabled={loading}
                            >
                                {loading ? "Updating..." : "Update Password"}
                            </button>
                        </form>

                        <button
                            className="cr-action-btn"
                            onClick={() => navigate("/sessions")}
                            style={{ marginTop: '20px', width: '100%', justifyContent: 'center' }}
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default ResetPassword;
